import { OptionType } from '@/common/presentation/components/forms/fields/FormikAutocomplete';

/**
 * Generic filter function for autocomplete options
 * Filters options by label containing the input value (case-insensitive)
 *
 * @param options - Array of OptionType options to filter
 * @param state - Object containing the inputValue string
 * @returns Filtered array of options matching the input value
 *
 * @example
 * const filtered = filterAutocompleteOptions(
 *   [{ value: 1, label: 'Option 1' }, { value: 2, label: 'Option 2' }],
 *   { inputValue: 'option' }
 * );
 * // Returns: [{ value: 1, label: 'Option 1' }, { value: 2, label: 'Option 2' }]
 */
export const filterAutocompleteOptions = (options: OptionType[], { inputValue }: { inputValue: string }): OptionType[] => {
  const searchLower = inputValue.toLowerCase();
  return options.filter((option) => option.label.toLowerCase().includes(searchLower));
};
